import { useCustomReportsActions } from './actions/useCustomReportsActions';
import { useGenericActions } from './actions/useGenericActions';
import { useMarketDataActions } from './actions/useMarketDataActions';
import { useUiActions } from './actions/useUiActions';
import { useMetricsActions } from './actions/useMetricsAction';
import { useAuthActions } from './actions/useAuthActions';
import { useJobsActions } from './actions/useJobsActions';

export type UseActions = ReturnType<typeof useGenericActions> &
  ReturnType<typeof useUiActions> &
  ReturnType<typeof useMarketDataActions> &
  ReturnType<typeof useCustomReportsActions> &
  ReturnType<typeof useAuthActions> &
  ReturnType<typeof useMetricsActions> &
  ReturnType<typeof useJobsActions>;

export const useActions = (): UseActions => {
  return {
    ...useGenericActions(),
    ...useUiActions(),
    ...useMarketDataActions(),
    ...useCustomReportsActions(),
    ...useMetricsActions(),
    ...useAuthActions(),
    ...useJobsActions(),
  };
};
